import React, { useContext } from "react";
import cx from "classnames";
import Button from "../../../common/components/Forms/Button/Button";
import { createGroupAPI } from "../../api/api";
import { QuoteGroupContext } from "../../providers/RootContextProvider";

interface IAdminNavigationProps {
    groupId: string;
    className?: string;
}

const AdminNavigation: React.FC<IAdminNavigationProps> = ({ groupId, className }) => {
    const { actions } = useContext(QuoteGroupContext);

    const handleClickEditableLink = (): void => {
        const linkURL = `${window.location.href}?groupId=${groupId}`;
        navigator.clipboard
            .writeText(linkURL)
            .then(() => {
                alert("Copied editable link");
            })
            .catch(() => {
                alert("Failed to copy test: " + linkURL);
            });
    };

    return (
        <div
            className={cx(
                "layout-flex-row--centered",
                "flex-gap-l",
                "text-font-size-m",
                "text-no-bold",
                "panel-basic",
                "padding-vertical-s",
                "padding-horizontal-m",
                {
                    [className]: !!className
                }
            )}>
            <h3 className="text-font-size-ml text-bold text-primary text-zero-margin">
                Admin Panel:
            </h3>
            <div>
                <span className="text-bold">GroupId:</span>&nbsp;{groupId}
            </div>
            <Button
                component="button"
                onClick={handleClickEditableLink}
                size="s"
                width="content">
                Copy Editable Link
            </Button>
            <Button
                component="button"
                onClick={async () => {
                    const groupResult = await createGroupAPI();
                    actions.resetState(groupResult.groupId);
                }}
                size="s"
                width="content">
                Create new Group
            </Button>
        </div>
    );
};

export default AdminNavigation;
